import React, { useEffect, useState } from "react";
import "../Sales/Sales.css";
import "./Quotations.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import invoiceImg from "../../../assets/images/State-Distributor/viewInvoice.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";

function createData1(product, productCode, qty, price, total) {
  return {
    product,
    productCode,
    qty,
    price,
    total,
  };
}

const rows1 = [
  createData1(
    "004",
    "Royal Green",
    "10L",
    "1200",
    "₹400",
    "₹4,80,000",
    "5%",
    "₹4,56,000"
  ),
  createData1(
    "004",
    "Royal Green",
    "10L",
    "1200",
    "₹400",
    "₹4,80,000",
    "5%",
    "₹4,56,000"
  ),
  createData1(
    "004",
    "Royal Green",
    "10L",
    "1200",
    "₹400",
    "₹4,80,000",
    "5%",
    "₹4,56,000"
  ),
];

export const SubViewQuotations = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { Id } = location.state || "";
  console.log("id", Id);

  const [viewQuotation, setViewQuotation] = useState({});

  async function FetchViewQuotation(Id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`quotation/${Id}/`);
      if (response.data.status === "success" || response.status === 200) {
        setViewQuotation(response.data.data);
        console.log(response.data.message || "date fetched successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "failed to fetch view quotation details"
      );
      console.log("failed to fetch view quotation details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchViewQuotation(Id);
  },[]);

  async function ConvertToSales(){
      try{
        setLoading(true);
        const payload ={
          quotation_id :Id,
        }
        const response= await axiosInstance.post("/quotation/convert-to-sale/",payload);
        if(response.data.status==="success" || response.status===200){
          toast.success(response.data.message || "Successfully converted to sales");
          console.log("Successfully converted to sales");
        }
  
      }catch(error){
        toast.error(error.response.data.message || "Failed convert to sales");
        console.log("Failed convert to sales");
      }finally{
        setLoading(false);
      }
    }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <div className="salesContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/sub-quotations" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="addModalTitle">Quotation Details</div>
          </div>
          <div className="invoiceContainer">
            <div className="invoiceContent">
              <div>QT-{viewQuotation?.QuotationId}</div>
              <div>{viewQuotation?.created_at}</div>
            </div>
            <div className="invoiceContent">
              <div>{viewQuotation?.state_distributor}</div>
              <div>
                <span>{viewQuotation?.address},</span>
                <br />
                <span>{viewQuotation?.city},{viewQuotation?.state}</span>
                <br />
                <span>{viewQuotation?.phone_number}</span>
                <br />
              </div>
            </div>
            <div className="invoiceImg">
              <img src={invoiceImg} />
            </div>
          </div>
          <div className="invoiceAddress">
            <div>Billed To:</div>
            <div
              style={{ color: "var(--color-font-primary)", fontWeight: "600" }}
            >
              {viewQuotation?.billed_to}
            </div>
            {/* <div>Sy no: 85/7, Kukatpally,</div>
            <div>Hyderabad, Telangana.</div>
            <div>9632587410</div> */}
          </div>
          {/* table  */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Product</TableCell>
                    <TableCell align="left">Product Code</TableCell>

                    <TableCell align="left">Qty</TableCell>
                    <TableCell align="left">Price/Unit (₹)</TableCell>
                    <TableCell align="left">Total (₹)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {viewQuotation?.order_items?.length > 0 ? (
                    viewQuotation.order_items.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">{row.product_name}</TableCell>
                        <TableCell align="left">
                          {row.product || "---"}
                        </TableCell>

                        <TableCell align="left">{row.qty}</TableCell>

                        <TableCell align="left">{row.price}</TableCell>
                        <TableCell align="left">{row.total}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        No orders available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* Totals */}
          <div className="addModalTotalContainer">
            <div>
              <div className="addModalContent">
                <span>Total Products:</span>
                <span>{viewQuotation?.total_products}</span>
              </div>
              <div className="addModalContent">
                <span>Total Value:</span>
                <span>{viewQuotation?.total_value}</span>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "20px" }}
            >
              <button className="addBtnCancel">Print Quotation</button>
              <button className="addBtnSave" onClick={()=>ConvertToSales()}>Convert to Sale</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
